import { render, staticRenderFns } from "./share-bar.vue?vue&type=template&id=17b05353&scoped=true"
import script from "./share-bar.vue?vue&type=script&lang=js"
export * from "./share-bar.vue?vue&type=script&lang=js"
import style0 from "./share-bar.vue?vue&type=style&index=0&id=17b05353&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b05353",
  null
  
)

export default component.exports